// extracted by mini-css-extract-plugin
export default {"switch":"Switch-module__switch__lmbML"};